import extend from 'licia/extend';
export default class Visitor {
    constructor() {
        this.id = 0;
        this.visited = [];
    }
    set(val, extra) {
        const { visited, id } = this;
        const obj = {
            id,
            val,
        };
        extend(obj, extra);
        visited.push(obj);
        this.id++;
        return id;
    }
    get(val) {
        const { visited } = this;
        for (let i = 0, len = visited.length; i < len; i++) {
            const obj = visited[i];
            if (val === obj.val)
                return obj;
        }
        return false;
    }
}
